import Binco from './Binco';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import ProductViewer from './ProductViewer';
import InfoBox from './InfoBox';
import Cart from './Cart';
import mine from 'assets/minesweeper/mine-icon.png';
import error from 'assets/windowsIcons/897(16x16).png';
import info from 'assets/windowsIcons/747(32x32).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';
import logoSmol from 'assets/logo_smol.png';

import userIcon from 'assets/windowsIcons/msn.png';
import ordersIcon from 'assets/windowsIcons/549(32x32).png';
import instagramIcon from 'assets/instagram.svg';

const bincoIcon = logoSmol;
const bincoIconSmall = logoSmol;
export const EXTERNAL_ACCOUNT = 'EXTERNAL_ACCOUNT';
export const EXTERNAL_ORDERS = 'EXTERNAL_ORDERS';
export const EXTERNAL_INSTAGRAM = 'EXTERNAL_INSTAGRAM';

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
export const defaultAppState = [
  {
    component: Binco,
    header: {
      title: 'binco - More Thrash For Less Cash',
      icon: bincoIconSmall,
    },
    defaultSize: {
      width: Math.min(1500, window.innerWidth - 220),
      height: Math.min(820, window.innerHeight - 80),
    },
    defaultOffset: {
      x: 120,
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 0,
    icon: bincoIcon,
    title: 'binco',
    component: Binco,
    isFocus: false,
  },
  {
    id: 1,
    icon: mine,
    title: 'Minesweeper',
    component: Minesweeper,
    isFocus: false,
  },
  {
    id: 3,
    icon: notepadLarge,
    title: 'about binco',
    component: Notepad,
    isFocus: false,
  },
  {
    id: 4,
    icon: winamp,
    title: 'Winamp',
    component: Winamp,
    isFocus: false,
  },
  {
    id: 5,
    icon: userIcon,
    title: 'My Account',
    component: EXTERNAL_ACCOUNT,
    isFocus: false,
    rightAlign: true,
  },
  {
    id: 6,
    icon: ordersIcon,
    title: 'My Orders',
    component: 'EXTERNAL_ORDERS',
    isFocus: false,
    rightAlign: true,
  },
  {
    id: 7,
    icon: instagramIcon,
    title: '@binco67.in',
    component: EXTERNAL_INSTAGRAM,
    isFocus: false,
    bottomRight: true,
  },
];

export const appSettings = {
  Binco: {
    header: {
      icon: bincoIconSmall,
      title: 'binco - More Thrash For Less Cash',
    },
    component: Binco,
    defaultSize: {
      width: Math.min(1200, window.innerWidth - 40),
      height: Math.min(750, window.innerHeight - 60),
    },
    defaultOffset: {
      x: 20,
      y: 5,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: 'Minesweeper',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: 'Untitled - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Winamp: {
    header: {
      icon: winamp,
      title: 'Winamp',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  ProductViewer: {
    header: {
      icon: logoSmol,
      title: 'Product',
    },
    component: ProductViewer,
    defaultSize: {
      width: Math.min(913, window.innerWidth - 200),
      height: Math.min(820, window.innerHeight - 80),
    },
    defaultOffset: {
      x: 180,
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Info: {
    header: {
      icon: info,
      title: 'binco',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: InfoBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Cart: {
    header: {
      icon: bincoIconSmall,
      title: 'Shopping Cart - binco',
    },
    component: Cart,
    defaultSize: {
      width: Math.min(360, window.innerWidth * 0.3),
      height: window.innerHeight - 60,
    },
    defaultOffset: {
      x: window.innerWidth - Math.min(360, window.innerWidth * 0.3) - 10,
      y: 0,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
};

export { Binco, Minesweeper, ErrorBox, MyComputer, Notepad, Winamp, ProductViewer, InfoBox, Cart };
